// extracted by mini-css-extract-plugin
export default {"Button":"BtnLink_Button__Z9Lmd","Gold":"BtnLink_Gold__ri48L"};